<template>
  <div>
    <PlanUpgradeTooltip
      v-if="isShowTooltip"
      :popup="popup"
      :planForFeature="planForFeature"
      @clickOutsideUpgrade="clickOutsideUpgrade"
      @openPlanUpgradeModal="openPlanUpgradeModal"
    >
      <template #tooptip v-if="$slots.tooltipcontent">
        <slot name="tooltipcontent" />
      </template>
    </PlanUpgradeTooltip>
    <PlanUpgradeModal
      :open-modal="openModal"
      @hide="openModal= false"
      :plan-for-feature="planForFeature"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import PlanUpgradeTooltip from '@/components-v2/presentation-editor/editor-header/PlanUpgradeTooltip.vue'
import PlanUpgradeModal from '@/components-v2/presentation-editor/editor-header/PlanUpgradeModal.vue'
import featuresByPlan from '@/components-v2/my-plan/user-pricing/featuresByPlan'
import Config from '@/config'
import Util from '@/util'
import eventCategories from '@/constant/eventCategories'

export default {
  name: 'EditorPlan',
  components: {
    PlanUpgradeTooltip,
    PlanUpgradeModal,
  },
  computed: {
    ...mapGetters(['isTreatmentPlanUpgradeEditor']),
  },
  props: {
    isShowTooltip: {
      type: Boolean,
      default: false,
    },
    planForFeature: {
      type: String,
      default: 'Pro',
    },
    nameFeature: {
      type: String,
      default: '',
    },
    textTooltip: {
      type: String,
      default: 'Upgrade to Pro to use this feature',
    },
    popup: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      openModal: false,
    }
  },

  methods: {
    openPlanUpgradeModal() {
      this.$emit('outsideEvent')
      if (this.nameFeature.length > 0) {
        Util.mixpanelTracking(
          eventCategories.PRESENTATION_EDITOR,
          'Feature upgrade',
          this.nameFeature,
        )
      }
      if (!this.isTreatmentPlanUpgradeEditor) {
        return this.$router.push('/apps/user-plan?redirect=/apps/user-plan')
      }
      if (this.planForFeature === 'Pro') {
        return this.goToUpgradePage(featuresByPlan.annual.updateLink.find((plan) => plan.permissionKey === 'proYearly').url)
      }
      this.openModal = true
    },
    goToUpgradePage(url) {
      // const plan = /content=([^&]+)/.exec(url)[1] || ''
      setTimeout(() => {
        const paramBackLink = `&back_link_to_presentation=${encodeURIComponent(window.location.href)}`
        window.location.href = `${Config.presenterDomain}${url}${paramBackLink}`
      }, 500)
    },
    clickOutsideUpgrade() {
      this.$emit('outsideEvent')
    },

  },
}
</script>

<style lang="scss" scoped>

</style>
